import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Session } from "../session/slice"

export type Realtime_item = "comment" | "demand" | "advertising" | "program" | "privilege" | "admin" | "operator" | "client" | "subscription" | "message" | "live" | "actuality" | "programrecord" | "reporting" | "advertisingplan" | "payement" | "streamrecord" | "webrtc" | "flux" | "playlist"
export type Realtime_status = "disconnected" | "connected" | "signed"
type Realtime = {
  [x in Realtime_item]: {
    namespace: x,
    status: "disconnected" | "connected" | "signed",
    event?: "connect" | "disconnect" | "message"
  }
}
const initialState: { value: Realtime } = {
  value: {
    comment: {
      namespace: "comment",
      status: "disconnected"
    },
    demand: {
      namespace: "demand",
      status: "disconnected",
    },
    advertising: {
      namespace: "advertising",
      status: "disconnected"
    },
    program: {
      namespace: "program",
      status: "disconnected"
    },
    privilege: {
      namespace: "privilege",
      status: "disconnected"
    },
    client: {
      namespace: "client",
      status: "disconnected",
    },
    admin: {
      namespace: "admin",
      status: "disconnected"
    },
    operator: {
      namespace: "operator",
      status: "disconnected"
    },
    subscription: {
      namespace: 'subscription',
      status: "disconnected"
    },
    message: {
      namespace: "message",
      status: "disconnected"
    },
    live: {
      namespace: "live",
      status: "disconnected"
    },
    actuality: {
      namespace: "actuality",
      status: "disconnected"
    },
    programrecord: {
      namespace: "programrecord",
      status: "disconnected"
    },
    reporting: {
      namespace: "reporting",
      status: "disconnected"
    },
    advertisingplan: {
      namespace: "advertisingplan",
      status: "disconnected"
    },
    payement: {
      namespace: "payement",
      status: "disconnected"
    },
    streamrecord: {
      namespace: "streamrecord",
      status: "disconnected"
    },
    webrtc: {
      namespace: "webrtc",
      status: "disconnected"
    },
    flux: {
      namespace: "flux",
      status: "disconnected"
    },
    playlist: {
      namespace: "playlist",
      status: "disconnected"
    }
  }
}

const realtimeSlice = createSlice({
  name: "realtime_slice",
  initialState,
  reducers: {
    connect: (state, action: PayloadAction<{ key: Realtime_item }>) => {
      state.value[action.payload.key].event = "connect"
    },
    disconnect: (state, action: PayloadAction<{ key: Realtime_item }>) => {
      state.value[action.payload.key].event = "disconnect"
    },
    emit: (state, action: PayloadAction<{ key: Realtime_item, event: string, data: any }>) => {
      state.value[action.payload.key].event = "message"
    },
    reset_event: (state, action: PayloadAction<{ key: Realtime_item }>) => {
      state.value[action.payload.key].event = undefined
    },
    setStatus: (state, action: PayloadAction<{ key: Realtime_item, status: Realtime_status }>) => {
      state.value[action.payload.key].status = action.payload.status
    },
    signout_all: (state, _action: PayloadAction<Session>) => {
      state.value = initialState.value
    }
  }
})

export const { connect, disconnect, setStatus, reset_event, emit, signout_all } = realtimeSlice.actions
export const realtime_slice = realtimeSlice.reducer